import styled from 'styled-components';
import { nonResponsiveSmallSpacedHeading, smallParagraph } from '../../../../theme/typography';
import { media } from '../../../../theme/media';
import { themeColor } from '../../../../theme/getters';
import { TargetLink } from '../../targetLink';

export const Container = styled.nav`
  text-align: left;
  margin-right: 72px;
  &:not(:last-child) {
    margin-bottom: 56px;
    ${media.tablet`
      margin-bottom: 0;
    `};
  }
`;
export const Title = styled.div`
  ${nonResponsiveSmallSpacedHeading};
  margin-bottom: 24px;
  color: ${themeColor('border')};
  ${media.tablet`
    margin-bottom: 40px;  
  `};
`;
export const Links = styled.ul`
  margin: 0;
  padding: 0;
`;
export const LinkWrapper = styled.li`
  display: block;
  &:not(:last-child) {
    margin-bottom: 16px;
  }
`;
export const Link = styled(TargetLink)`
  ${smallParagraph};
  color: ${themeColor('white')};
`;
